import { CheckboxField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledCheckboxCss = "s8n9hy";
const StyledCheckbox = forwardRef((props, ref) => <CheckboxField ref={ref} {...props} className={classNames(styledCheckboxCss, props.className)} />);
const linkWrapperCss = "l1qvzid5";
const LinkWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(linkWrapperCss, props.className)} />;
});
export const PassBookingDetailsField = () => <>
    <StyledCheckbox label={I18n.t('publisher.event_types.confirmation_page.info.pass_booking_details')} name="redirectConfiguration.passBookingDetails" />
    <LinkWrapper>
      <Link href="/help/hc/articles/360040257613" target="_blank" rel="noopener noreferrer">
        {I18n.t('publisher.action.learn_more')}
      </Link>
    </LinkWrapper>
  </>;

require("./pass_booking_details_field.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pass_booking_details_field.js");